import { Typography as MuiTypography } from '@material-ui/core';
/**
 * @deprecated Use type-specific variants instead. This will be removed in a future release.
 */
export const Typography = MuiTypography;
// All custom typography components as agreed upon with UX.
export * from './TypeBase';
export * from './TypeLabel';
export * from './TypeHelper';
export * from './TypePageTitle';
export * from './TypeSectionHeader';
export * from './TypeSubsectionHeader';
export * from './TypeWidgetHeader';
export * from './TypeTableHeader';
export * from './TypeHero';
export * from './TypeLegalese';
export * from './TypeCallout';
export * from './TypeDetailsHeader';
//# sourceMappingURL=index.js.map